let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lPHNP")).then(() => parcelRequire('avRxj'));